import { Stack } from "@mui/material";
import type { WorkbookRun } from "../../../../../api/types/workbookRuns.types";
import WorkbookReportsListActions from "../../common/WorkbookReportsListActions";
import CustomNumberFormatsAlert from "../../common/CustomNumberFormatsAlert";
import { RUN_CUSTOM_NUMBER_FORMATS_MESSAGE } from "../../common/workbookMessages";
import { isFinishedStatus } from "../workbookRunUtils";
import WorkbookRunDetailsActions from "./WorkbookRunDetailsActions";
import WorkbookRunDetailsAlert from "./WorkbookRunDetailsAlert";
import WorkbookRunInfoBar from "./WorkbookRunInfoBar";
import WorkbookRunReportsList from "./WorkbookRunReportsList";

interface Props {
  workbookRun: WorkbookRun;
  setWorkbookRun: (workbookRun: WorkbookRun) => void;
}

const WorkbookRunDetailsReports = ({ workbookRun, setWorkbookRun }: Props) => {
  return (
    <Stack spacing={2.5} sx={{ px: 3, py: 2.5, flex: 1 }}>
      <WorkbookRunDetailsAlert status={workbookRun.status} />
      {workbookRun.hasTooManyCustomNumberFormats && isFinishedStatus(workbookRun.status) && (
        <CustomNumberFormatsAlert text={RUN_CUSTOM_NUMBER_FORMATS_MESSAGE} />
      )}
      <WorkbookRunInfoBar workbookRun={workbookRun} />
      <WorkbookReportsListActions
        Actions={<WorkbookRunDetailsActions workbookRun={workbookRun} setWorkbookRun={setWorkbookRun} />}
      />
      <WorkbookRunReportsList workbookRun={workbookRun} />
    </Stack>
  );
};

export default WorkbookRunDetailsReports;
